angular.module('dnecom')
    .controller('FulfillmentDetailsController', ["$scope", "$http", "notifications", "wizardModal", function FulfillmentDetailsController($scope, $http, notifications, wizardModal) {
        $scope.transaction = TemplateData.value('transaction');
        $scope.fulfillmentDetails = TemplateData.value('fulfillmentDetails');
        $scope.store = TemplateData.value('store');
        $scope.editedDetails = null;

        $scope.getTruncatedText = function(text) {
            if (!text || text.length <= 10) {
                return text;
            }

            return text.substr(0, 10) + '...';
        };

        $scope.editFulfillmentRow = function (details) {
            $scope.editedDetails = angular.copy(details);
        };

        $scope.isBeingEdited = function (details) {
            return $scope.editedDetails ? $scope.editedDetails.id == details.id : false;
        };

        $scope.cancelEditFulfillmentRow = function () {
            $scope.editedDetails = null;
        };

        $scope.saveFulfillmentDetails = function () {
            $http.put(Routing.generate('fulfillment_details_update', {
                    id: $scope.editedDetails.id,
                    storeId: $scope.store.id
                }), $scope.editedDetails)
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    notifications.success(response.data.message);
                    $scope.syncEdits($scope.editedDetails);
                    $scope.cancelEditFulfillmentRow();
                }, function() {
                    notifications.danger('Request error.');
                });
        };

        $scope.syncEdits = function(savedDetails) {
            var replaceIdx = null;

            $scope.fulfillmentDetails.forEach(function(details, i){
                if (details.id == savedDetails.id) {
                    replaceIdx = i;
                }
            });

            if (replaceIdx !== null) {
                $scope.fulfillmentDetails[replaceIdx] = savedDetails;
            }
        };

        $scope.placeOrder = function(details) {
            if (details.fulfillmentOrder) {
                openReviewModal(details, [details.id]);
                return;
            }

            var multipleProductsFound = false;

            angular.forEach($scope.fulfillmentDetails, function(item) {
                if (item.id != details.id && item.sourceData.provider == details.sourceData.provider && !item.fulfillmentOrder) {
                    multipleProductsFound = true;
                }
            });

            if (!multipleProductsFound) {
                prepareOrder(details, 'single');
            } else {
                wizardModal.open({
                    'templateUrl': 'fulfillmentDetailsConfirmModal.html',
                    'controller': 'FulfillmentDetailsConfirmController',
                    'resolve': {
                        details: function() {
                            return details;
                        }
                    }
                }).result.then(function(mode) {
                    prepareOrder(details, mode);
                });
            }
        };

        var prepareOrder = function(details, mode) {
            var detailsIds = [];

            if (mode == 'single') {
                detailsIds.push(details.id);
            } else {
                angular.forEach($scope.fulfillmentDetails, function(item) {
                    if (item.sourceData.provider == details.sourceData.provider) {
                        detailsIds.push(item.id);
                    }
                });
            }

            $http
                .post(
                    Routing.generate('fulfillment_details_prepare_order', {storeId: $scope.store.id}),
                    {
                        detailsIds: detailsIds
                    }
                )
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    angular.forEach($scope.fulfillmentDetails, function(item) {
                        if (detailsIds.indexOf(item.id) >= 0) {
                            item.fulfillmentOrder = angular.copy(response.data.fulfillmentOrder);
                        }
                    });

                    openReviewModal(details, detailsIds);
                }, function() {
                    notifications.danger('Request error.');
                })
            ;
        };

        var openReviewModal = function(details, detailsIds) {
            wizardModal.open({
                'templateUrl': 'fulfillmentDetailsReviewModal.html',
                'controller': 'FulfillmentDetailsReviewController',
                'resolve': {
                    'transaction': function() {
                        return $scope.transaction;
                    },
                    'details': function() {
                        return details;
                    },
                    'quote': function() {
                        return details.fulfillmentOrder.properties.quote;
                    },
                    'products': function() {
                        return details.fulfillmentOrder.properties.products;
                    }
                }
            }).result.then(function() {
                makeOrder(details, detailsIds, details.fulfillmentOrder.properties.taskId, details.fulfillmentOrder.properties.quote);
            });
        };

        var makeOrder = function(details, detailsIds, orderId, quote) {
            $http
                .post(
                    Routing.generate('fulfillment_details_send_order', {
                        storeId: $scope.store.id
                    }),
                    {
                        orderId: orderId,
                        detailsIds: detailsIds,
                        prices: quote.prices
                    }
                )
                .then(function(response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    var index = 0;

                    angular.forEach($scope.fulfillmentDetails, function(item) {
                        if (detailsIds.indexOf(item.id) >= 0) {
                            item.number = response.data.fulfillmentOrder.properties.id;
                            item.price = quote.prices[index];
                            item.status = 'sent';
                            item.fulfillmentOrder = angular.copy(response.data.fulfillmentOrder);

                            index += 1;
                        }
                    });

                    notifications.success('Order placed successfully.');
                }, function() {
                    notifications.danger('Request error.');
                })
            ;
        };
    }]);
